interface SelectedAlertsListProps {
  selectedAlerts: string[];
}

function SelectedAlertsList({ selectedAlerts }: SelectedAlertsListProps): JSX.Element | null {
  if (selectedAlerts.length === 0) {
    return null;
  }

  return (
    <div className="App-selected-alerts">
      <div className="App-selected-header">
        <h3 className="App-selected-title">Active Alerts</h3>
        <span className="App-selected-count">{selectedAlerts.length} selected</span>
      </div>
      <div className="App-selected-list">
        {selectedAlerts.map((alert) => (
          <div key={alert} className="App-selected-item">
            <span className="App-selected-icon">✓</span>
            <span className="App-selected-text">{alert}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default SelectedAlertsList;

